import {React,createContext} from 'react'

export const Wishlistdata = createContext()


const addwishlist=(payload)=>{
    console.log(payload)
        }

        let allwishbtn={
            addwishlist 
        }



const Wishcontainer = ({children}) => {
  return (
    <div>
        <Wishlistdata.Provider value={allwishbtn}>
            {children}
        </Wishlistdata.Provider>
    </div>
  )
}

export default Wishcontainer